(function () {
  'use strict';

  angular
    .module('gallery.upload')
    .controller('galleryUploadCtrl', galleryUploadCtrl);

  galleryUploadCtrl.$inject = ['$rootScope', 'GalleryUpload', 'Upload'];

  function galleryUploadCtrl($rootScope, GalleryUpload, Upload) {
    var vm = this;
    vm.uploadFiles = uploadFiles;
    vm.getImages = getImages;
    vm.progress = 0;
    vm.images = [];

    if (!vm.accept) {
      vm.accept = 'image/*';
    }

    init();

    function init() {
      vm.getImages();
    }

    function uploadFiles(files) {
      angular.forEach(files, function (file) {
        if (file.$error && file.$error === 'maxSize') {
          alert(`Your file exceeds ${file.$errorParam}. Please, resize.`);
        }

        file.upload = Upload.upload({
          method: 'POST',
          url: '/images/upload?act=submit',
          file: file,
          fields: {
            type: vm.type,
            id: vm.id,
            token: $rootScope.token,
          },
        })
          .progress(function (evt) {
            vm.progress = parseInt((100.0 * evt.loaded) / evt.total);
          })
          .then(
            function (response) {
              if (vm.type == 'user') {
                vm.images = [{ path: response.data.result.path }];
                $rootScope.userAvatar = response.data.result.path;
              } else {
                // vm.images.push(response.data.result);
                // get the fresh list from backend
                vm.getImages();
              }
              vm.progress = 0;
            },
            function (errorResponse) {},
          );
      });
    }

    function getImages() {
      if (vm.type == 'user') {
        vm.images = [
          {
            path: $rootScope.userAvatar,
          },
        ];
      } else if (vm.type.includes('navi')) {
        GalleryUpload[vm.type](
          {
            id: vm.id,
          },
          function (response) {
            vm.images = response ? response : [];
          },
        );
      } else {
        GalleryUpload.houseImages(
          {
            id: $rootScope.houseId,
          },
          function (response) {
            vm.images = response ? response : [];
          },
        );
      }
    }
  }
})();
